import React from 'react'
import getYouTubeId from 'get-youtube-id'
import YouTube from 'react-youtube'

import styled from 'styled-components'

const Container = styled.article`
  position: relative;
  overflow: hidden;
  padding-top: 56.25%;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
`

export default ({ node }) => {
  const { url } = node
  const id = getYouTubeId(url)
  const opts = {
  }
  return (
    <Container>
      <YouTube
        videoId={id}
        opts={opts} />
    </Container>
  )
}
